<template>
  <div class="home-container">
    <!-- 顶部登录和语言选择 -->
    <div class="header">
      <div class="login-info">
        <img class="avatar" src="../../assets/imgs/icon_avatar.png"  />
        <span class="login-btn" @click="toLogin" v-if="!token">{{i18n.Log_In}}</span>
        <div>
          <div class="login-btn" v-if="token">{{ user.pname }}</div>
          <div v-if="token" @click="logout" class="logout-btn1">{{i18n.logout}}</div>
        </div>

      </div>

      <div class="language">
        <div class="setting-warp">
          <div class="setting-row" @click="isLangView = true">
            <span class="setting-row-label">{{locale.label}}</span>
            <img class="right" src="../../assets/imgs/right.png" alt="">
          </div>
          <select-lang v-model="isLangView"></select-lang>
        </div>
      </div>
    </div>

    <!-- 设备信息部分 -->
    <div class="device-info">
      <div class="info-item">
        <span class="label">{{i18n.Device_SN}}</span>
        <span class="value">{{ deviceSn }}</span>
      </div>
      <div class="info-item">
        <span class="label">{{i18n.Network_Status}}</span>
        <span class="value" v-if="onlineStatus==-1">......</span>
        <span class="value" v-if="onlineStatus==1 && isPackage">{{i18n.online}}</span>
        <span class="value" v-else>{{i18n.offline}}</span>
      </div>
      <div class="info-item">
        <span class="label">{{i18n.WiFi_Name}}</span>
        <span class="value">{{wifiName}}</span>
      </div>
      <div class="info-item">
        <span class="label">{{i18n.WiFi_Password}}</span>
        <span class="value">{{wifiPwd}}</span>
      </div>
    </div>

    <!-- 功能按钮组 -->
    <div class="function-buttons">
      <div class="function-item" @click="toIndictorLight">
        <img class="function-img" src="../../assets/imgs/icon-light.png"  />
        <div class="function-label">{{i18n.Indicator_Light_Description}}</div>
      </div>
      <div class="function-item" @click="toHelp">
        <img class="function-img" src="../../assets/imgs/icon-faq.png"  />
        <div class="function-label">{{i18n.faq}}</div>
      </div>
      <div class="function-item" @click="toContact">
        <img class="function-img" src="../../assets/imgs/icon-contactUs.png"  />
        <div class="function-label">{{i18n.Contact_Us}}</div>
      </div>
    </div>

    <div class="video-section">
      <!-- 视频播放 -->
      <div class="video-container" v-if="brandType === 1 || brandType === 2">
        <iframe
          class="video-player"
          src="https://www.youtube.com/embed/6_iBywWcKdM"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen>
        </iframe>
      </div>
      <div class="video-container" v-else>
        <iframe
          class="video-player"
          src="https://youtu.be/6eu2Sb_zka0"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen>
        </iframe>
      </div>
    </div>

    <!-- 套餐信息 -->
    <div class="package-info">
      <div class="package-l">{{i18n.Package_Information}}</div>
      <div class="package-r" @click="PurchasedPackages">{{i18n.Purchase_history}}</div>
    </div>
    <van-swipe  :autoplay="3000" indicator-color="#036EB8">
      <van-swipe-item v-for="(item, i) in orderList" :key="i">
        <div class="how-about" style="height: 200px;">
          <div class="refueling">
            <div class="country">
              {{item.country}}
            </div>
            <div class="pack" @click="goPackageOrder(item)" v-if="item.country !== '......'">
              {{i18n.refueling_pack}}
            </div>
          </div>
          <div class="total-refueling">{{item.text}}</div>
          <div class="use-progress">
            <Progress :progress="(100-parseFloat(item.packageUsageBalance)/parseFloat(item.packageUsageTotal)*100)" :strokeWidth="13" :showInfo="true" />
<!--            <Progress :progress="60" :strokeWidth="13" :showInfo="true" />-->
          </div>
          <div class="refueling-use">
            <div class="used">{{item.packageUsage? item.packageUsage: '--'}}MB {{i18n.used}}</div>
            <div class="Remaining">{{i18n.remaining}} {{item.packageUsageBalance? item.packageUsageBalance: '--'}}MB/{{item.total?item.total:'--'}}</div>
          </div>
          <div class="use-time">
            <div class="item1">{{i18n.start_time}}</div>
            <div class="item2">{{item.reserverStartTime}}</div>
          </div>
          <div class="use-time">
            <div class="item1">{{i18n.end_time}}</div>
            <div class="item2">{{item.reserverEndTime}}</div>
          </div>
        </div>
      </van-swipe-item>
    </van-swipe>

    <!-- 热门国家和地区 -->
    <div class="popular-regions">
      <div class="package-l-r">{{i18n.Popular_countries_and_regions}}</div>
      <div class="region-grid">
        <div class="region-item" v-for="(item, index) in countryPopularRecords" @click="goPackageOrder(item)">
          <img  :src="item.flagUrl" alt="USA" />
          <span>{{item.name}}</span>
        </div>
      </div>
      <div class="more-regions" @click="goWifimall">
        <span>{{i18n.More_countries_and_regions}}</span>
      </div>
    </div>

    <!-- 热门套餐 -->
    <div class="popular-packages" style="display: none">
      <div class="popular-pack">{{i18n.Popular_Packages}}</div>
      <div class="package-grid">
        <div class="package-item" v-for="(item, index) in popularRecords" @click="goPackageOrder2(item)" :key="index">
          <img :src="item.flagUrl" alt="Japan" />
          <span>{{item.country}} {{item.text}}</span>
        </div>

      </div>
    </div>
    <van-dialog v-model="show" title="" :show-cancel-button="false" :show-confirm-button="false" width="380px">
      <van-icon name="cross" class="cross-btn" @click="show = false" />
      <div class="package-title">
        {{i18n.data_has_been_used_up}}
      </div>
      <div style="max-height: 40vh;overflow: auto;">
        <div v-for="item in packageDtlList" class="pakage-box flex-s" :class="packageClass(item)" @click="selectPack(item)" :key="item.skuId">
          <div class="pakage-text">{{ item.text }}</div>
          <div class="pakage-price">{{ item.price }}</div>
        </div>
      </div>
      <div class="tip">
        {{i18n.original_traffic}}
      </div>
      <div style="text-align: center">
        <van-button @click="buyNow" class="bottom-pakage-btn">{{ i18n.Buy1 }}</van-button>
      </div>
    </van-dialog>
    <van-dialog v-model="methodShow" title="" :show-cancel-button="false" :show-confirm-button="false" width="380px">
      <div class="logout-btn" @click="onLogout">{{i18n.logout}}</div>
      <div class="package-title-view">
        {{i18n.Scan_QR_code}}
      </div>
      <div class="method-box">
        <van-image :src="require('assets/imgs/mifi-back.png')" width="105px"></van-image>
        <van-image :src="require('assets/imgs/mifi_back02.png')" class="method-img-r" ></van-image>
        <div class="method-label">{{i18n.ScanDevice}}</div>
      </div>
      <div style="text-align: center;padding: 10px">
        <button class="confirm-dial-btn" @click="toScan">{{i18n.ScanQrBtn}}</button>
      </div>
    </van-dialog>
    <van-dialog v-model="methodContactShow" title="" :show-cancel-button="false" :show-confirm-button="false" width="380px">
      <van-icon name="cross" class="cross-btn" @click="methodContactShow = false" />
      <div class="contact">
        <div class="contact-item" @click="openMailClient">
          <van-image class="contact-img" :src="require('assets/imgs/icon_contact_email.png')"></van-image>
          <p>{{i18n.sendEmail}}</p>
        </div>
        <div class="contact-item" @click="toWhatsApp">
          <van-image class="contact-img" :src="require('assets/imgs/icon_contact_whatapp.png')"></van-image>
          <p>{{i18n.sendWhatApp}}</p>
        </div>
      </div>
    </van-dialog>
    <van-dialog v-model="logoutShow" title="" :show-cancel-button="false" :show-confirm-button="false" width="280px">
      <div class="package-title-view">
        {{i18n.logoutMsg}}
      </div>
      <div style="text-align: center;padding: 10px">
        <button class="btn-cancel"  @click="toLogoutCancel">{{i18n.cancel}}</button>
        <button class="btn-logout " @click="onLogout">{{i18n.comfirm}}</button>
      </div>
    </van-dialog>
    <div class="fixed" v-if="isPickUpShow" @click="isPickUpShow = false">
      <ScanQr @scanQr="onScanQr" />
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import { PopupWarp } from '@/components/popup'
import { MenuSide } from '@/components/menu'
import Progress from '@/components/result/Progress'
import {
  MIFI_COUNTRY_POPULAR_LIST,
  MIFI_DEFAULT_DEVICE,
  MIFI_DEVICE,
  MIFI_DEVICE_SECRET, MIFI_PACKAGE_POPULAR_LIST,
  MIFI_PAY_LIST,
  MIFI_POPULAR_LIST,
  MIFI_QR_CODE, MIFI_QR_CODE_BRAND
} from '@/apis/cabinet'
import ScanQr from 'views/scanQr/scanQr.vue'
import { USER_INFO } from '@/apis/user'
import dayjs from 'dayjs'
import { SelectLang } from 'components/select'
export default {
  components: {
    SelectLang,
    Progress,
    ScanQr
  },
  data () {
    return {
      list: [],
      item: null,
      show: false,
      methodShow: false,
      isMenuView: false,
      methodContactShow: false,
      searchText: '',
      percent: 80,
      packageObj: {
        skuId: 0
      },
      logoutShow: false,
      packageDtlList: [],
      deviceInfo: null,
      deviceItems: [],
      isPickUpShow: false,
      orderList: [
        {
          country: '......',
          text: '......',
          start_time: '......',
          reserverStartTime: '......',
          end_time: '......',
          reserverEndTime: '......'
        }
      ],
      isPackage: false,
      typeMap: {},
      startTime: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'),
      endTime: '',
      packageCount: 1,
      packageName: '',
      isLangView: false,
      wifiName: '......',
      wifiPwd: '......',
      deviceSn: '......',
      onlineStatus: -1,
      popularRecords: [],
      countryPopularRecords: [],
      brandType: 1
    }
  },
  computed: {
    ...mapState(['user', 'token', 'browser', 'qrcode']),
    ...mapGetters(['locale']),
    i18n () {
      return this.$t('home')
    },
    i18nMsg () {
      return this.$t('msg')
    },
    i18nSetting () {
      return this.$t('setting')
    }
  },
  watch: {
    latLng () {
      this.lazyLoad(this)
    }
  },
  methods: {
    toWhatsApp() {
      if (this.brandType === 1) {
        const phoneNumber = '15360129730'; // 替换为实际的电话号码（不带国家代码）
        const countryCode = '+86'; // 替换为实际的国家代码
        const url = `https://wa.me/${countryCode}${phoneNumber}`;
        window.open(url, '_blank');
      } else if (this.brandType === 2) {
        const phoneNumber = '15360129730'; // 替换为实际的电话号码（不带国家代码）
        const countryCode = '+86'; // 替换为实际的国家代码
        const url = `https://wa.me/${countryCode}${phoneNumber}`;
        window.open(url, '_blank');
      } else {
        const phoneNumber = '13925003135'; // 替换为实际的电话号码（不带国家代码）
        const countryCode = '+86'; // 替换为实际的国家代码
        const url = `https://wa.me/${countryCode}${phoneNumber}`;
        window.open(url, '_blank');
      }
    },
    openMailClient() {
      if (this.brandType === 1) {
        const emailData = {
          to: 'AbruoadFi@outlook.com' // 收件人邮箱
        };
        const mailtoLink = `mailto:${emailData.to}`;
        window.location.href = mailtoLink;
      } else if (this.brandType === 2){
        const emailData = {
          to: 'Tobedorao@outlook.com' // 收件人邮箱
        };
        const mailtoLink = `mailto:${emailData.to}`;
        window.location.href = mailtoLink;
      } else {
        const emailData = {
          to: 'business@gzzbjkj.com' // 收件人邮箱
        };
        const mailtoLink = `mailto:${emailData.to}`;
        window.location.href = mailtoLink;
      }
      // const emailData = {
      //   to: 'AbruoadFi@outlook.com' // 收件人邮箱
      // };
      // const mailtoLink = `mailto:${emailData.to}`;
      // window.location.href = mailtoLink;
    },
    toLogin() {
      this.$router.push('/otherLogin')
    },
    deviceManagement() {
      this.$router.push('/deviceManager')
    },
    PurchasedPackages() {
      if (this.deviceSn != null) {
        this.$router.push('/PurchasedPackages?deviceSn=' + this.deviceSn)
      } else {
        this.$router.push('/PurchasedPackages?deviceSn')
      }
    },
    addEquipment() {
      this.$router.push('/activityDevice')
    },
    packageClass (item) {
      return item.skuId === this.packageObj.skuId ? 'h-pakage' : ''
    },
    selectPack (item) {
      this.packageObj = item
      this.mifiPackage = item
      this.packageCount = item.Day
      this.packageName = item.text
      this.endTime = dayjs(this.startTime).add(item.Day, 'day').format('YYYY-MM-DD HH:mm:ss')
    },
    buyNow() {
      let order = this.packageObj
      order.startTime = this.startTime
      order.endTime = this.endTime
      order.productSendSn = this.deviceSn
      //  order.xugou = false
      let totalAmount = this.packageObj.price
      this.$store.commit("mifiOrder", order)
      this.$router.push({
        path: "/confirm",
        query: { price: totalAmount, payType: "mifi", currency: this.packageObj.currency, 'mifisn': this.deviceSn }
      })
    },
    logout() {
      this.logoutShow = true
    },
    onLogout () {
      this.$store.commit('user', null)
      this.$store.commit('token', '')
      this.$store.commit('appleIdToken', '')
      this.$store.commit('mifisn', null)
      this.$store.commit('mifiDevices', null)
      this.$router.push('/otherLogin?brandType=' + this.brandType)
      this.$store.commit('user', null)
    },
    toLogoutCancel() {
      this.logoutShow = false
    },
    toIndictorLight() {
      this.$router.push('/indicatorLight1')
    },
    toHelp() {
      this.$router.push('/help')
    },
    faq() {
      this.$router.push('/packageOrder')
    },
    toContact() {
      this.methodContactShow = true
    },
    deviceList() {
      this.$post(
        MIFI_DEFAULT_DEVICE, {}, (resp) => {
          if (resp.cdbUserMifi) {
            this.deviceSn = resp.cdbUserMifi.psn
            console.log(this.deviceSn)
            if (this.deviceSn !== '') {
              this.mifiSecrt()
              this.getOrderList()
            } else {
              this.methodShow = true
            }
          } else {
            this.methodShow = true
          }
        },
        (error) => {
          this.$loading(false)
          this.$toast(error)
        }
      )
    },

    packagePopularList() {
      this.$post(
        MIFI_PACKAGE_POPULAR_LIST, {}, (resp) => {
          let data = resp.data.records
          data = data.map(item => {
            item.Day = item.packageName.split('-')[2].includes('Days') ? (item.packageName.split('-')[2]).split('Days')[0] : 1
            if (item.packageName.split('-')[2].includes('Days')) {
              item.text = `${item.packageName.split('-')[1]}/${(item.packageName.split('-')[2]).split('Days')[0]}${this.i18n.天}`
              item.isPackage = 1
              item.total = `${item.packageName.split('-')[1]}`
            } else if (item.packageName.split('-')[2].includes('Unlimited')) {
              item.text = `${this.i18n.无限流量}/${item.Day}${this.i18n.天}`
              item.isPackage = 0
              item.total = `${this.i18n.无限流量}`
            } else {
              item.text = `${item.packageName.split('-')[2]}MB/${this.i18n.天}`
              item.isPackage = 0
              item.total = `${item.packageName.split('-')[2]}`
            }
            return item
          })
          this.popularRecords.push(...data)
        },
        (error) => {
          this.$loading(false)
          this.$toast(error)
        }
      )
    },
    countryPopuarlList() {
      this.$post(
        MIFI_COUNTRY_POPULAR_LIST, {}, (resp) => {
          let data = resp.data.records
          this.countryPopularRecords.push(...data)
        },
        (error) => {
          this.$loading(false)
          this.$toast(error)
        }
      )
    },

    mifiSecrt () {
      var url = `${MIFI_DEVICE_SECRET}${this.deviceSn}`
      this.$get(url, { }, res => {
          if (res.data) {
            console.log(res.data)
            this.wifiName = res.data.wifiSSID
            this.wifiPwd = res.data.wifiPassword
            this.onlineStatus = res.data.onlineStatus
            this.brandType = res.data.brandType
          }
        },
        err => {
          console.log(err)
          this.$toast(err)
        },
        {
          headers: {
            // agentOpenId: !this.isProd ? 'oDn2e4hi8M1iVtXcxm1uYpKTPEBE' : ''
            agentOpenId: 'oDn2e4hi8M1iVtXcxm1uYpKTPEBE' // 正式
          }
        }
      )
    },
    goWifimall () {
      this.methodShow = false
      if (this.deviceSn) {
        this.$router.push('/wifiMall?type=GM&deviceSn=' + this.deviceSn)
      }
    },
    checkPOP() {
      if (this.deviceItems.length > 0) {
        this.goWifimall()
      } else {
        this.methodShow = true
      }
    },
    scanPop() {
      this.methodScanShow = true
    },
    toScan() {
      this.methodShow = false
      this.methodScanShow = true
      this.scanQr()
    },
    refuelingPack(item) {
      this.initPackage(item);
      this.show = true
    },
    scanQr() {
      // this.deviceSn = 'srq311370m5wyrwm'
      // this.$store.commit('mifisn', this.deviceSn)
      // this.$router.push('/wifiMall?type=GM&deviceSn=' + this.deviceSn)
      this.isPickUpShow = true
    },
    onScanQr(qr) {
      this.isPickUpShow = false
      this.onScan(qr)
    },
    onScan(urlcode) {
      this.$post(MIFI_QR_CODE,
        {
          url: encodeURIComponent(urlcode)
        },
        resp => {
          this.deviceSn = resp.data
          if (this.deviceSn === '' || this.deviceSn === null || this.deviceSn === undefined) {
            this.methodShow = true
            this.$toast(this.i18n.scanMsg)
          } else {
            this.methodShow = false
            this.$store.commit('mifisn', this.deviceSn)
            this.$router.push('/')
            this.deviceList()
          }
        },
        error => {
          this.methodShow = true
          this.$toast(this.i18n.scanMsg)
        }
      )
    },
    queryBrand(urlcode) {
      this.$post(MIFI_QR_CODE_BRAND,
        {
          url: encodeURIComponent(urlcode)
        },
        resp => {
          var brandType = resp.data
          this.$router.push('/otherLogin?brandType=' + brandType+'&url=' + encodeURIComponent(urlcode))
        }
      )
    },
    loadUser () {
      let $this = this
      this.$get(
        USER_INFO,
        {},
        res => {
          if (res.user) {
            $this.$store.commit('user', res.user)

            var qr = this.$route.query.qr
            if (qr) {
              var path = window.location.href;
              $this.onScan(path)
              this.methodShow = false
            }
          }
        },
        err => {
          this.$loading(false)
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: err,
            showCancel: false
          }).then(() => {
            this.$store.commit('token', null)
          })
        }
      )
    },
    getOrderList () {
      this.$post('/chargenow/mifi/orderList', {
          current: 1,
          size: 20,
          payStatus: 1,
          // orderStatus: 5,
          type: 'home',
          sn: this.deviceSn
        }, res => {
          this.$loading(false)
          let data = res.data.records
          data = data ? data.map(item => {
            item.Day = item.packageName.split('-')[2].includes('Days') ? (item.packageName.split('-')[2]).split('Days')[0] : 1
            if (item.packageName.split('-')[2].includes('Days')) {
              item.text = `${item.packageName.split('-')[1]}/${(item.packageName.split('-')[2]).split('Days')[0]}${this.i18n.天}`
              item.isPackage = 1
              item.total = `${item.packageName.split('-')[1]}`
            } else if (item.packageName.split('-')[2].includes('Unlimited')) {
              item.text = `${this.i18n.无限流量}/${item.Day}${this.i18n.天}`
              item.isPackage = 0
              item.total = `${this.i18n.无限流量}`
            } else {
              item.text = `${item.packageName.split('-')[2]}MB/${this.i18n.天}`
              item.isPackage = 0
              item.total = `${item.packageName.split('-')[2]}`
            }
            item.packageStatusTitle = this.typeMap[item.packageStatus]
            return item
          }) : []
          if (data.length > 0) {
            this.orderList = []
          }
          for (var i = 0; i < data.length; i++) {
            if (data[i].packageStatus < 3) {
              this.orderList.push(data[i])
            }
            this.isPackage = true
          }
          if (this.orderList.length === 0) {
            this.orderList = [
              {
                country: '......',
                text: '......',
                start_time: '......',
                reserverStartTime: '......',
                end_time: '......',
                reserverEndTime: '......'
              }
            ]
            this.isPackage = false
          }
          // this.orderList.push(...data)
          // this.orderList = data
        },
        error => {
          this.$loading(false)
          console.log(error)
        }
      )
    },
    initPackage(item) {
      var skuId = item.skuId
      var country = item.country
      this.$post('chargenow/mifi/query', {
        'requestMethod': 'post',
        'url': '/mifi-open-api/wifiBase/packageDtlListBySkuId',
        'data': {
          'skuId': skuId,
          'country': country
        }
      }, (res) => {
        this.packageDtlList = JSON.parse(res.data)
        console.log(this.packageDtlList)
        this.packageDtlList = this.packageDtlList.map(item => {
          item.Day = item.packageName.split('-')[2].includes('Days') ? (item.packageName.split('-')[2]).split('Days')[0] : 1
          if (item.packageName.split('-')[2].includes('Days')) {
            item.text = `${item.packageName.split('-')[1]}/${(item.packageName.split('-')[2]).split('Days')[0]}天`
            item.isPackage = 1
          } else if (item.packageName.split('-')[2].includes('Unlimited')) {
            item.text = `${this.i18n.无限流量}/${item.Day}${this.i18n.天}`
            item.isPackage = 0
          } else {
            item.text = `${item.packageName.split('-')[2]}MB/${this.i18n.天}`
            item.isPackage = 0
          }
          console.log(item)
          return item
        })
        this.packageObj = { ...this.packageDtlList[0] }
        this.mifiPackage = this.packageObj
        this.packageName = this.packageObj.text
        this.endTime = dayjs(this.startTime).add(this.packageObj.Day, 'day').format('YYYY-MM-DD HH:mm:ss')
        console.log('流量套餐列表===', this.packageDtlList)
      }, error => {
        console.log(error)
      }, {
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      })
    },
    goPackageOrder(item) {
      if (!this.token) {
        this.toLogin()
        return
      }

      if (item.country === '......') {
        return
      }
      item.country = item.name
      this.$router.push('/packageOrder?type=1&deviceSn=' + this.deviceSn + '&item=' + encodeURIComponent(JSON.stringify(item)))
    },
    goPackageOrder2(item) {
      if (!this.token) {
        this.toLogin()
        return
      }

      if (item.country === '......') {
        return
      }
      // item.country = item.name
      this.$router.push('/packageOrder?type=1&deviceSn=' + this.deviceSn + '&item=' + encodeURIComponent(JSON.stringify(item)))
    }
  },
  created () {
    this.packagePopularList()
    this.countryPopuarlList()
    if (this.token) {
      this.loadUser()
    }
    if (this.user) {
      this.deviceList()
    }
    this.typeMap = {
      0: this.i18n.type_0,
      1: this.i18n.type_1,
      2: this.i18n.type_2,
      3: this.i18n.type_3,
      4: this.i18n.type_4,
      9: this.i18n.type_9,
      33: this.i18n.type_33,
      88: this.i18n.type_88
    }
    var qr = this.$route.query.qr
    if (qr) {
      var path = window.location.href;
      if (this.user) {
        this.onScan(path)
      } else {
        this.queryBrand(path)
      }
    }
  },
  mounted () {
  }
}
</script>
<style scoped>
.home-container {
  padding: 20px;
  background: #F4F4F4;
}
.btn-cancel{
  background: white;
  color: #3ca2fc;
  border: #3ca2fc 1px solid;
  border-radius: 8px;
  padding: 5px;
  margin: 10px;
  width: 150px;
}
.btn-logout{
  background: #3ca2fc;
  color: white;
  border: #3ca2fc 1px solid;
  border-radius: 8px;
  padding: 5px;
  margin: 10px;
  width: 150px;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.login-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.avatar {
  width: 90px;
  height: 90px;
  border-radius: 50%;
}
.login-btn{
  font-family: MyFont2;
  font-weight: 400;
  font-size: 24px;
  color: #000000;
}
.language{
  font-family: MyFont2;
  font-weight: 400;
  font-size: 24px;
  color: #000000;
}
.label{
  font-family: MyFont2;
  font-weight: 700;
  font-size: 26px;
  color: #666666;
  width: 40%;
}
.value{
  font-family: MyFont2;
  font-weight: 700;
  font-size: 28px;
  color: #000000;
}
.device-info {
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 20px;
}

.info-item {
  display: flex;
  margin-bottom: 12px;
}

.function-buttons {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin-bottom: 20px;
}

.function-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #E0F2FB;
  padding: 16px;
  border-radius: 8px;

}
.function-img {
  width: 98px;
  height: 85px;
}
.function-label{
  font-family: MyFont2;
  font-weight: 700;
  font-size: 22px;
  color: #000000;
  height: 54px;
  align-content:center;
  text-align: center;
}
.package-info {
  display: flex;
  justify-content: space-between;
  padding: 20px 0;
}
.package-l{
  font-family: MyFont3;
  font-weight: bold;
  font-size: 30px;
  color: #000000;
}
.package-l-r{
  font-family: MyFont3;
  font-weight: bold;
  font-size: 30px;
  color: #000000;
  padding: 10px 0 ;
}
.package-r{
  font-family: MyFont2;
  font-weight: 700;
  font-size: 20px;
  filter: brightness(110%);
  color: #00A29A;
}
.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.usage-bar {
  height: 12px;
  background: #eee;
  border-radius: 6px;
  margin: 8px 0;
}

.region-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  margin-bottom: 16px;
}

.region-item {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #ffffff;
  padding: 20px;
  border-radius: 16px;
}

.region-item img {
  width: 77px;
  height: 51px;
}
.region-item span {
  margin-left: 40px;
  font-family: MyFont2;
  font-weight: 900;
  font-size: 22px;
  color: #000000;
}

.link {
  color: #007AFF;
}

.more-regions {
  text-align: center;
  color: #036EB8;
  padding: 20px;
  background: #fff;
  border-radius: 16px;
  border: 1px solid #036EB8;
  filter: brightness(110%);;
}
.popular-pack{
  font-family: MyFont3;
  font-weight: bold;
  font-size: 30px;
  color: #000000;
  padding: 15px 0;
}

.package-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.package-item {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #fff;
  padding: 20px;
  border-radius: 8px;
}

.package-item img {
  width: 77px;
  height: 51px;
}
.package-item span {
  margin-left: 15px;
}

.how-about{
  background: #FFFFFF;
  box-shadow: 0px 4px 16px 1px rgba(0,0,0,0.08);
  border-radius: 18px 18px 18px 18px;
}
.refueling{
  display: flex;
}
.refueling-use{
  display: flex;
  padding: 20px;
  font-family: MyFont2;
  font-weight: bold;
  font-size: 22px;
  color: #333333;
}
.Remaining{
  text-align: right;
  width: 60%;
}
.used{
  width: 40%;
}
.total-refueling{
  font-family: MyFont2;
  font-weight: normal;
  font-size: 32px;
  color: #333333;
  padding: 30px 0 22px 20px;
  font-weight: bold;
}
.country{
  width: 50%;
  min-height: 58px;
  max-height: 88px;
  background: #036EB8;
  border-radius: 18px 0px 18px 0px;
  color: #ffffff;
  font-size: 30px;
  font-family: MyFont2;
  text-align: center;
  align-content: center;
  font-weight: bold;
}
.pack{
  font-family: MyFont3;
  font-weight: bold;
  font-size: 24px;
  color: #036EB8;
  font-weight: bold;
  text-align: right;
  width: 50%;
  padding: 15px 20px 0 0;
}
.use-time{
  display: flex;
  font-family: MyFont2;
  font-weight: 400;
  font-size: 22px;
  color: #666666;
  padding: 10px 20px 10px 20px;
}
.item1{
  width: 30%;
}
.item2{
  width: 70%;
  text-align: right;
}
.video-section {
  margin-bottom: 20px;
}

.video-container {
  background: #fff;
  border-radius: 16px;
  padding: 16px;
  box-shadow: 0px 4px 16px 1px rgba(0,0,0,0.08);
}

.video-player {
  width: 100%;
  height: 200px;
  border-radius: 8px;
}

.fixed{
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 100%;
}
.cross-btn{
  position: absolute;
  right: 30px;
  top: 30px;
  font-size: 40px;
}

.method-img-r{
  position: absolute;
  margin-left: 85px;
  width: 244px;
}
.method-box{
  padding: 20px 20px 40px 20px;
}
.method-label{
  font-family: MyFont2;
  font-weight: 900;
  font-size: 22px;
  color: #333333;
  width: 4.2rem;
  margin-left: 3.5rem;
  margin-top: -1.3rem;
  filter: brightness(10%);
}
.confirm-dial-btn{
  height: 80px;
  width: 390px;
  background: #036EB8;
  border-radius: 40px 40px 40px 40px;
  border: 2px solid #036EB8;
  color: #FFFFFF;
}
.package-title{
  text-align: center;
  padding: 104px 40px 66px 40px;
  font-family: MyFont3;
  font-weight: 400;
  font-size: 28px;
  color: #333333;
}
.package-title-view{
  padding: 50px 40px 30px 40px;
  font-family: MyFont3;
  font-weight: 600;
  font-size: 28px;
  color: #333333;
}
.contact{
  display: flex;
  margin: 20px;
  padding: 60px 0 20px 0;
}
.contact-item{
  width: 50%;
  text-align: center;
}
.contact-item p{
  font-family: MyFont2;
  font-weight: 900;
  font-size: 24px;
  color: #000000;
  filter: brightness(210%);
}

.contact-img{
  background: #DDEBF2;
  width: 130px;
  height: 105px;
  padding: 20px;
  border-radius: 30px;
}
.logout-btn{
  text-align: right;
  width: 100%;
  font-family: MyFont2;
  font-weight: 800;
  font-size: 28px;
  color: #00A29A;
  margin-left: -35px;
  margin-top: 15px;

}
.logout-btn1{
  width: 100%;
  font-family: MyFont2;
  font-weight: 800;
  font-size: 28px;
  color: #00A29A;

}
.setting-warp {
  padding: 0px;
}
.setting-main {
  padding: 24px;
  background-color: #fff;
  border-radius: 20px;
  box-shadow: 4px 4px 20px rgba(0, 0, 0, 0.2);
}
.setting-row {
  height: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  padding-right: 40px;
}
.right {
  position: absolute;
  width: 36px;
  height: 36px;
  right: 0;
}
.setting-row-label {
  color: #727070;
}
.pakage-box {
  margin: 20px;
  position: relative;
  background: #FFFFFF;
  border-radius: 18px 18px 18px 18px;
  border: 1px solid #D1D1D1;
  padding: 17px 20px;
}
.pakage-text{
  width: 70%;
  font-family: MyFont2;
  font-weight: bold;
  font-size: 22px;
  color: #333333;
  line-height: 30px;
}
.pakage-price {
  font-family: MyFont3;
  font-size: 30px;
  font-weight: bold;
  color: #FF1919;
}
.tip{
  font-family: MyFont4;
  font-weight: 300;
  font-size: 22px;
  color: #666666;
  text-align: center;
  padding: 20px;
}
.bottom-pakage-btn{
  font-weight: 400;
  font-size: 24px;
  color: #036EB8;
  width: 280px;
  height: 76px;
  border-radius: 40px 40px 40px 40px;
  margin: 30px;
  border: 2px solid #036EB8;
}
.h-pakage {
  border: 3px solid #036EB8;
}
.fixed{
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 100%;
}
</style>
